<template>
	<div>
		<app-ad></app-ad>

		<div class="pt-7 pb-4">
			<v-container class="text-center">
				<v-row>
					<v-col v-for="item in pinned" :key="item.index" cols="12" md="4" sm="6">
						<router-link v-if="item.to" :to="item.to">
							<v-hover v-slot="{ hover }">
								<v-img
									contain
									class="news-item"
									:class="hover ? 'zoom' : ''"
									transition="scale-transition"
									:alt="item.title"
									:src="item.coverPic"
									aspect-ratio="2"
								>
									<template #placeholder>
										<v-row class="fill-height ma-0" align="center" justify="center">
											<v-progress-circular indeterminate color="primary"></v-progress-circular>
										</v-row>
									</template>

									<v-row justify="center" align="end" class="fill-height ma-0">
										<v-col cols="12">
											<h2 class="text-h6 font-weight-bold">{{ item.title }}</h2>
											<h3 class="pt-2 text-body-1 font-weight-bold">{{ item.description }}</h3>
										</v-col>
									</v-row>
								</v-img>
							</v-hover>
						</router-link>
						<a v-else :href="item.url">
							<v-hover v-slot="{ hover }">
								<v-img
									contain
									class="news-item"
									:class="hover ? 'zoom' : ''"
									transition="scale-transition"
									:alt="item.title"
									:src="item.coverPic"
									aspect-ratio="2"
								>
									<template #placeholder>
										<v-row class="fill-height ma-0" align="center" justify="center">
											<v-progress-circular indeterminate color="primary"></v-progress-circular>
										</v-row>
									</template>

									<v-row justify="center" align="end" class="fill-height ma-0">
										<v-col cols="12">
											<h2 class="text-h6 font-weight-bold">{{ item.title }}</h2>
											<h3 class="pt-2 text-body-1 font-weight-bold">{{ item.description }}</h3>
										</v-col>
									</v-row>
								</v-img>
							</v-hover>
						</a>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div class="pb-0">
			<v-container>
				<v-row>
					<v-col cols="12">
						<v-card style="max-width: calc(3 * 300px + 12px); margin: auto;">
							<v-tabs v-model="tab" centered show-arrows>
								<v-tab v-for="section in sections" :key="section.title">{{ section.title }}</v-tab>
							</v-tabs>
							<v-tabs-items v-model="tab">
								<v-tab-item v-for="section in sections" :key="section.tiitle">
									<app-home-courses v-if="section.tab == 'courses'"></app-home-courses>

									<app-home-news v-if="section.tab == 'news'"></app-home-news>

									<app-home-replacements v-if="section.tab == 'replacements'"></app-home-replacements>

									<app-home-events v-if="section.tab == 'events'"></app-home-events>

									<app-home-jobs v-if="section.tab == 'jobs'"></app-home-jobs>

									<app-home-library v-if="section.tab == 'library'"></app-home-library>
								</v-tab-item>
							</v-tabs-items>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<app-ad></app-ad>

		<app-sponsors></app-sponsors>
	</div>
</template>

<script>
import client from "@/client";
export default {
	name: "Home",
	components: {
		"app-home-courses": () => import("@/components/home/AppHomeCourses"),
		"app-home-news": () => import("@/components/home/AppHomeNews"),
		"app-home-replacements": () => import("@/components/home/AppHomeReplacements"),
		"app-home-events": () => import("@/components/home/AppHomeEvents"),
		"app-home-jobs": () => import("@/components/home/AppHomeJobs"),
		"app-home-library": () => import("@/components/home/AppHomeLibrary"),
		"app-sponsors": require("@/components/general/AppSponsors").default,
		"app-ad": require("@/components/general/AppAd").default
	},
	mixins: [require("@/mixins/router-mixin").default],
	data() {
		return {
			tab: 0,
			pinned: [],
			sections: [
				{
					title: "الدورات التديبية",
					tab: "courses",
					icon: "mdi-teach"
				},
				{
					title: "الأخبار العامة",
					tab: "news",
					icon: "mdi-newspaper"
				},
				{
					title: "النقل ببديل",
					tab: "replacements",
					icon: "mdi-account-switch"
				},
				{
					title: "الفعاليات",
					tab: "events",
					icon: "mdi-calendar"
				},
				{
					title: "الوظائف الطبية",
					tab: "jobs",
					icon: "mdi-doctor"
				},
				{
					title: "المكتبة الطبية",
					tab: "library",
					icon: "mdi-library"
				}
			]
		};
	},
	mounted() {
		this.getPinned();
	},
	methods: {
		getPinned() {
			client
				.get("/api/pinTopic/all")
				.then(response => {
					console.log(response);
					this.pinned = Object.values(response.data).map(
						(record, index) => {
							record.index = index;
							if (record.relatedModel == 'courses') {
								record.to = { name: 'course', params: { courseID: record.relatedID } }
							} else if(record.relatedModel == 'news') {
								record.to = { name: 'news-item', params: { recordID: record.relatedID } }
							} else if(record.relatedModel == 'events') {
								record.to = { name: 'event', params: { recordID: record.relatedID } }
							} else if(record.relatedModel == 'jobs') {
								record.to = { name: 'job', params: { jobID: record.relatedID } }
							} else if(record.relatedModel == 'replacements') {
								record.to = { name: 'replacement', params: { recordID: record.relatedID } }
							} else if(record.relatedModel == 'library') {
								record.to = { name: 'library-item', params: { recordID: record.relatedID } }
							} 

							return record;
						}
					);
				})
				.catch(err => {
					console.log(err);
				});
		},
	}
};
</script>

<style scoped>
.news-item ::v-deep .v-image__image {
	max-width: 500;
	max-height: 300;
	transition: 1s;
}

.zoom ::v-deep .v-image__image {
	transform: scale(1.5);
}

.news-item .col {
	margin-bottom: calc(-50% + 45px);
	transition: 1s;
	height: 100%;
}

.news-item.zoom .col {
	margin-bottom: 0;
	background-color: rgba(0, 0, 0, 0.4);
	color: white;
}
</style>
